<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleRechargeNew">充值</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-tickets" size="small" @click="handleView(scope.row)">查看明细</el-button>
          <el-button type="text" icon="el-icon-plus" size="small" @click="handleRecharge(scope.row)">充值</el-button>
        </template>
      </avue-crud>

      <!-- 充值弹窗 -->
      <el-dialog title="材料账户充值" :visible.sync="rechargeVisible" width="500px" :close-on-click-modal="false">
        <el-form :model="rechargeForm" ref="rechargeFormRef" label-width="120px" :rules="rechargeRules">
          <el-form-item label="选择施工员" prop="userId" v-if="rechargeMode === 'new'">
            <el-select v-model="rechargeForm.userId" filterable remote reserve-keyword
              placeholder="请输入施工员姓名或手机号搜索" :remote-method="remoteSearchEngineer"
              :loading="engineerSearchLoading" style="width: 100%;" @change="handleEngineerSelect">
              <el-option v-for="item in engineerOptions" :key="item.id"
                :label="item.realName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="施工员姓名" v-if="rechargeMode === 'row'">
            <el-input v-model="rechargeForm.userName" disabled />
          </el-form-item>
          <el-form-item label="施工员手机号" v-if="rechargeMode === 'row'">
            <el-input v-model="rechargeForm.userMobile" disabled />
          </el-form-item>
          <el-form-item label="施工员姓名" v-if="rechargeMode === 'new' && rechargeForm.userName">
            <el-input v-model="rechargeForm.userName" disabled />
          </el-form-item>
          <el-form-item label="施工员手机号" v-if="rechargeMode === 'new' && rechargeForm.userMobile">
            <el-input v-model="rechargeForm.userMobile" disabled />
          </el-form-item>
          <el-form-item label="充值金额(元)" prop="amount">
            <el-input-number v-model="rechargeForm.amount" :min="0.00" :max="1000000" :precision="2" :step="10"
              placeholder="请输入充值金额" style="width: 100%;" />
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input v-model="rechargeForm.remarks" placeholder="请输入备注" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="rechargeVisible = false">取 消</el-button>
          <el-button type="primary" :loading="rechargeLoading" @click="submitRecharge">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 账户明细弹窗 -->
      <account-detail :visible="detailVisible" :user-id="currentUserId" :user-name="currentUserName" @close="closeDetail" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { materialAccountV2TableOption } from "@/const/work/waterProof/materialAccountV2Option";
import { getMaterialAccountLogList, rechargeMaterialAccount, findEngineerUserList } from "@/api/work/waterProof/materialAccountV2";
import AccountDetail from './materialAccountDetail.vue';

export default {
  name: "materialAccountV2",
  components: {
    AccountDetail
  },
  data() {
    return {
      tableOption: materialAccountV2TableOption,
      tableData: [],
      tableLoading: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // 充值相关
      rechargeVisible: false,
      rechargeLoading: false,
      rechargeMode: 'row', // 'row' 行内充值 | 'new' 左侧按钮充值
      rechargeForm: {
        userId: '',
        userName: '',
        userMobile: '',
        amount: null,
        remarks: ''
      },
      rechargeRules: {
        userId: [
          { required: true, message: '请选择施工员', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' }
        ]
      },
      // 工程师远程搜索
      engineerSearchLoading: false,
      engineerOptions: [], // 搜索结果选项
      // 明细相关
      detailVisible: false,
      currentUserId: '',
      currentUserName: '',
      // 搜索参数缓存
      searchParams: {}
    };
  },
  created() {
    this.handleList();
  },
  computed: {
    ...mapGetters(["permission"])
  },
  methods: {
    // 获取材料账户列表
    handleList() {
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchParams
      };
      getMaterialAccountLogList(params).then(res => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || {};
          this.tableData = data.rows || [];
          this.page.total = data.total || 0;
        } else {
          this.tableData = [];
          this.page.total = 0;
          this.$message.error('获取材料账户列表失败');
        }
      }).catch(() => {
        this.tableLoading = false;
        this.tableData = [];
        this.page.total = 0;
        this.$message.error('获取材料账户列表异常');
      });
    },

    // 查看明细
    handleView(row) {
      this.currentUserId = row.userId;
      this.currentUserName = row.userName;
      this.detailVisible = true;
    },

    // 打开充值弹窗（从行按钮）
    handleRecharge(row) {
      this.rechargeMode = 'row';
      this.rechargeForm = {
        userId: row.userId,
        userName: row.userName,
        userMobile: row.userMobile,
        amount: null,
        remarks: ''
      };
      this.rechargeVisible = true;
      this.$nextTick(() => {
        this.$refs.rechargeFormRef && this.$refs.rechargeFormRef.clearValidate();
      });
    },

    // 打开充值弹窗（从左侧按钮，远程搜索工程师）
    handleRechargeNew() {
      this.rechargeMode = 'new';
      this.rechargeForm = {
        userId: '',
        userName: '',
        userMobile: '',
        amount: null,
        remarks: ''
      };
      this.engineerOptions = [];
      this.rechargeVisible = true;
      this.$nextTick(() => {
        this.$refs.rechargeFormRef && this.$refs.rechargeFormRef.clearValidate();
      });
    },

    // 远程搜索工程师
    remoteSearchEngineer(query) {
      if (query === '' || !/^\d{8,}$/.test(query)) {
        this.engineerOptions = [];
        return;
      }
      this.engineerSearchLoading = true;
      findEngineerUserList({ type: 'JOINS_ENGINEER', mobile: query }).then(res => {
        this.engineerSearchLoading = false;
        if (res.code === '200') {
          const data = JSON.parse(res.data) || [];
          this.engineerOptions = Array.isArray(data) ? data : (data.rows || []);
        } else {
          this.engineerOptions = [];
        }
      }).catch(() => {
        this.engineerSearchLoading = false;
        this.engineerOptions = [];
      });
    },

    // 选择工程师后填充信息
    handleEngineerSelect(userId) {
      const engineer = this.engineerOptions.find(item => item.id === userId);
      if (engineer) {
        this.rechargeForm.userName = engineer.realName;
        this.rechargeForm.userMobile = engineer.mobile;
      }
    },

    // 提交充值
    submitRecharge() {
      this.$refs.rechargeFormRef.validate((valid) => {
        if (!valid) return;
        if (!this.rechargeForm.userId) {
          this.$message.error('请选择施工员');
          return;
        }
        if (this.rechargeForm.amount <= 0) {
          this.$message.error('充值金额必须大于0');
          return;
        }
        this.$confirm(`确认为 ${this.rechargeForm.userName} 充值 ${this.rechargeForm.amount} 元吗？`, '充值确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.rechargeLoading = true;
          rechargeMaterialAccount(this.rechargeForm).then(res => {
            this.rechargeLoading = false;
            if (res.code === '200') {
              this.$message.success('充值成功');
              this.rechargeVisible = false;
              this.handleList();
            } else {
              this.$message.error(res.message || '充值失败');
            }
          }).catch(() => {
            this.rechargeLoading = false;
            this.$message.error('充值异常');
          });
        }).catch(() => {});
      });
    },

    // 关闭明细弹窗
    closeDetail() {
      this.detailVisible = false;
      this.currentUserId = '';
      this.currentUserName = '';
      // 关闭明细后刷新列表（余额可能因删除操作变化）
      this.handleList();
    },

    // 搜索
    searchChange(params, done) {
      this.searchParams = {};
      if (params.userName) this.searchParams.userName = params.userName;
      if (params.userMobile) this.searchParams.userMobile = params.userMobile;
      this.page.currentPage = 1;
      this.handleList();
      done && done();
    },

    // 刷新
    refreshChange() {
      this.handleList();
    },

    // 分页大小变化
    pageSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.handleList();
    },

    // 页码变化
    pageChange(page) {
      this.page.currentPage = page;
      this.handleList();
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>
